import { useRef, useState } from 'react';
import Logo from '../../uber-assets/ROTY2025_Logo.svg';
import { Footer, FooterContent } from './footer';
import { PHASES } from '../model/phases';



export function Nav({scrollToSection, currentPhase, scrollY}) {
    const menuTimeout = useRef(null);
    const [renderMenu, setRenderMenu] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const toggleMenu = (forcedState) => {
        if (forcedState === undefined) {
            forcedState = !menuActive;
        } else {
            if (forcedState === menuActive) {
                return;
            }
        }
        clearTimeout(menuTimeout.current);
        if (forcedState) {
            setRenderMenu(true);
            menuTimeout.current = setTimeout(() => {
                setMenuActive(true);
            }, 10);
            window.document.body.style.overflowY = 'hidden';
        } else {
            menuTimeout.current = setTimeout(() => {
                setRenderMenu(false);
            }, 400);
            setMenuActive(false);
            window.document.body.style.overflowY = 'auto';
        }
    }

    const scrollToSectionMob = (section) => {
        scrollToSection(section, true);
        toggleMenu(false);
    }

    // vary opacity of nav background based on scroll position
    const navOpacity = window.innerWidth >= 840 ? Math.min(1, Math.max(0, (scrollY - 50) / 50)) : 1;
    const navStyle = {
        backgroundColor: `rgba(6, 193, 103, ${navOpacity})`, // white background with variable opacity
    };

    return (
        <nav style={navStyle}>
            <div className='nav-content-constraint'>
                <div className="burger-menu" onClick={() => toggleMenu()}></div>
                <img className="nav-logo" src={Logo} alt="Uber Eats Restaurant of the Year Logo" onClick={() => scrollToSection('top')} />
                <div className='grow'></div>
                <div className='nav-links'>
                    {/* <div className='nav-link' onClick={() => scrollToSection('top')}>About</div> */}
                    <div className='nav-link' onClick={() => scrollToSection('roty')}>Restaurant of the Year</div>
                    <div className='nav-link' onClick={() => scrollToSection('trailblazers')}>Trailblazers Awards</div>
                    {currentPhase !== PHASES.WINNERS &&
                       <div className='nav-link' onClick={() => scrollToSection('prevWinners')}>2024 Winners</div>
                    }
                    {/* <div className='nav-link' onClick={() => scrollToSection('faq')}>FAQs</div> */}
                </div>
                {renderMenu &&
                    <>
                        <div className={`mob-blackout${menuActive ? ' active' : ''}`} onClick={() => toggleMenu(false)}></div>
                        <div className={`mob-menu${menuActive ? ' active' : ''}`}>
                            {/* <button className='nav black' onClick={() => scrollToSectionMob('top')}>About</button> */}
                            <button className='nav black' onClick={() => scrollToSectionMob('roty')}>Restaurant of the Year</button>
                            <button className='nav black' onClick={() => scrollToSectionMob('trailblazers')}>Trailblazers Awards</button>
                            {currentPhase !== PHASES.WINNERS &&
                                <button className='nav black' onClick={() => scrollToSectionMob('prevWinners')}>2024 Winners</button>
                            }
                            {/* <button className='nav black' onClick={() => scrollToSectionMob('faq')}>FAQs</button> */}
                            <div className='grow'></div>
                            <div className='mob-menu-bottom'>
                                <FooterContent isInMenu={true} />
                            </div>
                        </div>
                    </>
                }
            </div>
        </nav>
    );
}
